import React from "react"
import { useDebouncedCallback } from "use-debounce"
import RangeSlider from "../../../../../ui/molecules/RangeSlider"
import { useAlgoliaSearchState } from "../../controller/state"

export const PriceRangeFilter = () => {
  const { uiFilters, updateSearchParams } = useAlgoliaSearchState()

  const max = uiFilters?.price.max

  const handleChange = (values: number[]) => {
    if (!max) {
      return
    }
    if (values[0] > 0 && values[1] < max) {
      updateSearchParams((state) => {
        return {
          ...state,
          price: undefined,
        }
      })
    } else {
      updateSearchParams((state) => {
        return {
          ...state,
          price: {
            minPrice: values[0],
            maxPrice: values[1],
          },
        }
      })
    }
  }

  const debounced = useDebouncedCallback((values: number[]) => {
    handleChange(values)
  }, 100)

  if (!max) {
    return <></>
  }

  return (
    <RangeSlider
      defaultValue={[0, max]}
      onChange={debounced}
      max={max as number}
    />
  )
}
